import { getItem, setItem } from '@ms/yammer-libs-local-storage';

type PersistRingId = (appName: string, ringId: string | undefined) => void;
export const persistRingId: PersistRingId = (appName, ringId) => {
  if (!ringId) {
    return;
  }
  const key = `${appName}::ringId`;
  setItem(key, ringId);
};

type GetRingId = (appName: string) => string | null;
export const getRingId: GetRingId = (appName) => {
  const key = `${appName}::ringId`;

  return getItem(key);
};
